import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
	/**************************************************
	 * BEFORE DEPLOYING TO AZURE:
	 * Uncomment one clientId. This tells Azure which app registration this app is using.
	 * Uncomment one redirectUri. This tells Azure where to send you after you log in.
	**************************************************/
	auth: {//LOCAL
        instance: "https://hwienvironmental.ciamlogin.com/", //Doesn't change by environment
        authority: "https://login.microsoft.com/hwienvironmental.onmicrosoft.com", //Doesn't change by environment

		// CHOOSE ONE: UI App Registration Client ID
		//clientId: "220c1f5f-82e3-4348-9d47-be4f2df6873f", // DEV & Local
	   	clientId: "a9fc8f59-e5c4-485f-960b-b1990875fdec", // TEST
		//clientId: "e84f91cc-90ed-483e-9977-2d6f2b5f4871", // PROD

		// CHOOSE ONE: UI App Service URI
		//redirectUri: "http://localhost:3000/", // Local
		//redirectUri: "https://hwi-online-ui-test-ffgxcedbcsgzandn.centralus-01.azurewebsites.net/", // TEST OLD: Original ugly azure domainnpm run build
		redirectUri: "https://app-test.hwienvironmental.com", // TEST
        //redirectUri: "https://hwi-online-ui-prod-evdfhhc6enf9cmdh.centralus-01.azurewebsites.net", // PROD
	},

    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: unknown, message: unknown, containsPii: unknown) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        //console.info(message);
                        return;
                    case LogLevel.Verbose:
                        //console.debug(message);
                        return;
                    case LogLevel.Warning:
                        //console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

export const loginRequest = {
    scopes: ["User.Read"]
};

export const graphServiceConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me" //e.g. https://graph.microsoft.com/v1.0/me
};


/**************************************************
 * BEFORE DEPLOYING TO AZURE:
 * Uncomment one of the scopes. This controls authorization to hit the API from the UI.
 * You can only have one at a time, even though it's an array and it looks like you can have more.
 * As of 11/19/24 the TEST scope does not work. This is because the API project code explicitely uses the DEV scope so if you try to use test they won;t match.
**************************************************/
export const apiRequest = {
	scopes: [
		//"api://5152474d-7118-4179-afe5-0f0c5857cb1e/Management.Write", // DEV & Local
		"api://686e30c6-da81-4128-8e98-01dce7af3009/Management.Write"  // TEST
		//"api://e70bb7c5-7101-47b8-a09d-f09c5d97a9a1/Management.Write"  // PROD
	], 
};


/**************************************************
 * BEFORE DEPLOYING TO AZURE:
 * Uncomment one of the "default" options. This controls the base api url.
 * Ignore the other (local/dev/test) options. They should only be used for debugging locally.
**************************************************/
export const apiConfig = {
	//default: "https://localhost:7156", // Local
	//default: "https://hwi-online-api-dev-epdgaqc8geegc8ax.eastus-01.azurewebsites.net", // DEV
	default: "https://hwi-online-api-test-ergbh7hbhmfqbga4.centralus-01.azurewebsites.net", // TEST
	//default: "https://hwi-online-api-prod-bse5hgavaegsahbm.centralus-01.azurewebsites.net // PROD
	
	local: "https://localhost:7156",
	dev: "https://hwi-online-api-dev-epdgaqc8geegc8ax.eastus-01.azurewebsites.net",
	test: "https://hwi-online-api-test-ergbh7hbhmfqbga4.centralus-01.azurewebsites.net",
};

